/* AppTilesGridContainer.ts generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import * as React from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives/responsive';
const _5 = "@media (min-width:64rem){._1rqt13mt{grid-template-columns:repeat(3,minmax(0,1fr))}._pdlmhiv4{gap:var(--ds-space-400)}}";
const _4 = "@media (min-width:48rem) and (max-width:63.99rem){._1da79sye{grid-template-columns:repeat(2,minmax(0,1fr))}._1gzvl6l0{gap:var(--ds-space-300)}}";
const _3 = "._1p57l6l0{row-gap:var(--ds-space-300)}";
const _2 = "._yv0eihcf{grid-template-columns:repeat(1,minmax(0,1fr))}";
const _ = "._1e0c11p5{display:grid}";
export const AppTilesGridContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c11p5 _yv0eihcf _1p57l6l0 _1da79sye _1gzvl6l0 _1rqt13mt _pdlmhiv4", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  AppTilesGridContainer.displayName = 'AppTilesGridContainer';
}